import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
export function SelectField({ control, name, label, placeholder, disabled, options, description, className, onChange, }) {
    return (<FormField control={control} name={name} render={({ field }) => (<FormItem className={cn('space-y-2', className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <Select onValueChange={(value) => {
                field.onChange(value);
                onChange?.(value);
            }} value={field.value}>
                        <FormControl>
                            <SelectTrigger disabled={disabled} className="w-full">
                                <SelectValue placeholder={placeholder}/>
                            </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                            {placeholder && <SelectItem value="0">{placeholder}</SelectItem>}
                            {options.map((option, index) => (<SelectItem key={`select-item-${index}}`} value={option.value} disabled={option.disabled}>
                                    {option.icon ? (<span className="flex items-center gap-2">
                                            <span className="flex h-4 w-4 shrink-0 items-center justify-center text-muted-foreground">
                                                {option.icon}
                                            </span>
                                            <span>{option.label}</span>
                                        </span>) : (option.label)}
                                </SelectItem>))}
                        </SelectContent>
                    </Select>
                    <FormMessage />
                    {description && <FormDescription>{description}</FormDescription>}
                </FormItem>)}/>);
}
